(function () {
  'use strict';

  class GommaDotProduct extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('[data-product-form]');
      const idInput = this.querySelector('[data-variant-id]');
      if (idInput && !idInput.name) idInput.name = 'id';
      this.optionController = null;
      this.addEventListener('change', (event) => {
        if (event.target.matches('[data-option-value-id]')) this.onOptionValueChange(event);
        if (event.target.matches('[name="quantity"]')) this.updateTotal();
      });
      this.querySelectorAll('[data-quantity-preset]').forEach((button) => button.addEventListener('click', () => {
        const input = this.querySelector('[name="quantity"]');
        if (!input) return;
        input.value = button.dataset.quantityPreset;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }));
      this.querySelectorAll('[data-gallery-thumb]').forEach((button) => button.addEventListener('click', () => this.showMedia(button.dataset.galleryThumb)));
      const zoom = this.querySelector('[data-product-zoom-dialog]');
      this.querySelector('[data-product-zoom]')?.addEventListener('click', () => {
        const source = this.querySelector('.product-gallery__media.is-active > img');
        if (!source || !zoom) return;
        const enlarged = source.cloneNode();
        enlarged.loading = 'eager';
        enlarged.sizes = '90vw';
        zoom.querySelector('[data-product-zoom-image]').replaceChildren(enlarged);
        zoom.showModal();
      });
      zoom?.querySelector('[data-product-zoom-close]')?.addEventListener('click', () => zoom.close());
      zoom?.addEventListener('click', (event) => { if (event.target === zoom) zoom.close(); });
      if (this.form) this.form.addEventListener('submit', (event) => this.addToCart(event));
      this.updateTotal();
    }

    updateTotal() {
      const input = this.querySelector('[name="quantity"]');
      if (!input) return;
      const quantity = Math.min(Number(input.max || 99), Math.max(Number(input.min || 1), Math.floor(Number(input.value) || 1)));
      input.value = String(quantity);
      const unitPrice = this.querySelector('[data-unit-price]')?.dataset.unitPrice;
      const price = unitPrice ? Number(unitPrice) : NaN;
      const total = this.querySelector('[data-product-total]');
      if (total) total.textContent = Number.isFinite(price) ? new Intl.NumberFormat(document.documentElement.lang || 'it-IT', { style: 'currency', currency: this.dataset.currency || 'EUR' }).format(price * quantity / 100) : '—';
      const label = this.querySelector('[data-product-quantity-label]');
      if (label) label.textContent = quantity === 1 ? '1 pneumatico' : `${quantity} pneumatici`;
      this.querySelectorAll('[data-quantity-preset]').forEach((button) => button.setAttribute('aria-pressed', String(Number(button.dataset.quantityPreset) === quantity)));
      this.querySelectorAll('[data-quantity-change]').forEach((button) => {
        button.disabled = Number(button.dataset.quantityChange) < 0 ? quantity <= Number(input.min || 1) : quantity >= Number(input.max || 99);
      });
    }

    copyState(nextProduct, selector) {
      const current = this.closest('.product-page').querySelector(selector);
      const next = nextProduct.closest('.product-page').querySelector(selector);
      if (current && next) current.replaceWith(next.cloneNode(true));
    }

    async onOptionValueChange(event) {
      const picker = event.target.closest('[data-option-value-selectors]');
      if (!picker) return;
      const selectedIds = Array.from(picker.querySelectorAll('[data-option-value-id]:checked')).map((input) => input.dataset.optionValueId).filter(Boolean);
      const productUrl = event.target.dataset.productUrl || this.dataset.productUrl;
      const publicUrl = new URL(productUrl, window.location.origin);
      if (selectedIds.length) publicUrl.searchParams.set('option_values', selectedIds.join(','));

      if (publicUrl.pathname !== new URL(this.dataset.productUrl, window.location.origin).pathname) {
        window.location.assign(publicUrl.toString());
        return;
      }

      if (this.optionController) this.optionController.abort();
      const controller = new AbortController();
      this.optionController = controller;
      const requestUrl = new URL(publicUrl);
      requestUrl.searchParams.set('section_id', this.dataset.sectionId);
      const focusId = event.target.id;
      const button = this.querySelector('[data-add-to-cart]');
      if (button) {
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
      }
      this.setAttribute('aria-busy', 'true');

      try {
        const response = await fetch(requestUrl.toString(), { signal: controller.signal });
        if (!response.ok) throw new Error(String(response.status));
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const nextProduct = html.querySelector('g-product');
        if (!nextProduct) throw new Error('Missing product section');

        this.copyState(nextProduct, '[data-product-availability]');
        this.copyState(nextProduct, '.product-purchase__price');
        this.copyState(nextProduct, '.product-purchase__four');
        this.copyState(nextProduct, '[data-product-sku]');
        this.copyState(nextProduct, '[data-product-barcode]');
        this.copyState(nextProduct, '[data-checkout-tyre-properties]');
        this.updateTotal();

        const nextPicker = nextProduct.querySelector('[data-option-value-selectors]');
        if (nextPicker) picker.innerHTML = nextPicker.innerHTML;
        const idInput = this.querySelector('[data-variant-id]');
        const nextIdInput = nextProduct.querySelector('[data-variant-id]');
        if (idInput && nextIdInput) {
          idInput.value = nextIdInput.value;
          idInput.disabled = nextIdInput.disabled;
        }
        const nextButton = nextProduct.querySelector('[data-add-to-cart]');
        if (button && nextButton) {
          button.disabled = nextButton.disabled;
          button.innerHTML = nextButton.innerHTML;
        }
        const notify = this.querySelector('[data-product-notify]');
        if (notify && nextButton) notify.hidden = !nextButton.disabled;
        const nextActiveMedia = nextProduct.querySelector('.product-gallery__media.is-active');
        if (nextActiveMedia?.dataset.productMedia) this.showMedia(nextActiveMedia.dataset.productMedia);
        history.replaceState({}, '', publicUrl.toString());
        const focusTarget = document.getElementById(focusId);
        if (focusTarget) focusTarget.focus();
      } catch (error) {
        if (error.name !== 'AbortError') window.location.assign(publicUrl.toString());
      } finally {
        if (this.optionController === controller) {
          this.optionController = null;
          this.removeAttribute('aria-busy');
          const currentButton = this.querySelector('[data-add-to-cart]');
          if (currentButton) currentButton.removeAttribute('aria-busy');
        }
      }
    }

    showMedia(id) {
      this.querySelectorAll('[data-product-media]').forEach((media) => media.classList.toggle('is-active', media.dataset.productMedia === id));
      this.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => thumb.setAttribute('aria-current', String(thumb.dataset.galleryThumb === id)));
      const zoomButton = this.querySelector('[data-product-zoom]');
      if (zoomButton) zoomButton.hidden = !this.querySelector('.product-gallery__media.is-active > img');
    }

    async addToCart(event) {
      if (!window.GommaDotTheme || (event.submitter && !event.submitter.matches('[data-add-to-cart]'))) return;
      event.preventDefault();
      const button = this.form.querySelector('[type="submit"]');
      if (button) await window.GommaDotTheme.addFormToCart(this.form, button);
    }
  }

  const similarText = (value) => String(value ?? '').trim().toUpperCase();
  const construction = (tyre) => {
    const code = similarText(tyre.construction);
    if (/RADIAL|^Z?R$/.test(code)) return 'R';
    if (/DIAGON|^D$|^-$/.test(code)) return '-';
    if (code === 'B') return 'B';
    return similarText(tyre.size).match(/(ZR|R|B|-)\s*\d/)?.[1].replace('ZR', 'R') || code;
  };
  const loadAtLeast = (source, candidate) => {
    const a = similarText(source), b = similarText(candidate);
    if (!a || !b) return false;
    if (!/^\d+(\/\d+)*$/.test(a) || !/^\d+(\/\d+)*$/.test(b)) return a === b;
    const required = a.split('/').map(Number), actual = b.split('/').map(Number);
    return required.length === actual.length && required.every((value, index) => actual[index] >= value);
  };
  const speedAtLeast = (source, candidate) => {
    const a = similarText(source), b = similarText(candidate);
    const order = ['F', 'G', 'J', 'K', 'L', 'M', 'N', 'P', 'Q', 'R', 'S', 'T', 'U', 'H', 'V', 'W', 'Y'];
    if (!a || !b) return false;
    return order.includes(a) && order.includes(b) ? order.indexOf(b) >= order.indexOf(a) : a === b;
  };
  const position = (tyre) => {
    const text = `${tyre.position || ''}|${tyre.specifics || ''}`.toLowerCase();
    if (/\b(front|anteriore|avant)\b/.test(text)) return 'front';
    if (/\b(rear|posteriore|arrière)\b/.test(text)) return 'rear';
    return similarText(tyre.position);
  };
  function isSimilarTyre(source, candidate) {
    if (!candidate.available || String(source.id) === String(candidate.id)) return false;
    if (source.ean && source.ean === candidate.ean) return false;
    if (!source.vehicle || source.vehicle !== candidate.vehicle) return false;
    const dimensions = ['width', 'height', 'rim'];
    if (dimensions.every((key) => Number(source[key]) > 0)) {
      if (!dimensions.every((key) => Number(source[key]) === Number(candidate[key]))) return false;
    } else if (!source.sizeTag || source.sizeTag !== candidate.sizeTag) return false;
    if (source.season !== candidate.season) return false;
    if (Boolean(source.runflat) !== Boolean(candidate.runflat) || (source.xl && !candidate.xl)) return false;
    const sourceConstruction = construction(source), candidateConstruction = construction(candidate);
    if (!sourceConstruction || sourceConstruction !== candidateConstruction) return false;
    if (!loadAtLeast(source.load, candidate.load) || !speedAtLeast(source.speed, candidate.speed)) return false;
    if (/\bDEMO\b/.test(similarText(source.specifics)) !== /\bDEMO\b/.test(similarText(candidate.specifics))) return false;
    if (source.vehicle === 'moto') {
      if (position(source) !== position(candidate)) return false;
      const tube = (tyre) => similarText(tyre.specifics).match(/\b(?:TL\/TT|TT\/TL|TT|TL)\b/)?.[0] || '';
      if (tube(source) !== tube(candidate)) return false;
    }
    return true;
  }
  window.GommaDotSimilarTyres = { isSimilarTyre };

  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.dataset.loading || this.observer || !this.dataset.url) return;
      const start = () => {
        if (!this.isConnected || this.dataset.loading) return;
        this.observer?.disconnect();
        this.observer = null;
        this.dataset.loading = 'true';
        this.controller = new AbortController();
        this.load();
      };
      // The element is hidden until results exist: observe its visible wrapper.
      const target = this.closest('.shopify-section') || this.parentElement;
      if ('IntersectionObserver' in window && target) {
        this.observer = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) start();
        }, { rootMargin: '600px 0px' });
        this.observer.observe(target);
      } else if (document.readyState === 'complete') {
        start();
      } else {
        this.onPageLoad = start;
        window.addEventListener('load', start, { once: true });
      }
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.observer = null;
      window.removeEventListener('load', this.onPageLoad);
      this.controller?.abort();
      // Permit retries when the theme editor removes and reinserts this section.
      if (!['ready', 'empty'].includes(this.dataset.state)) delete this.dataset.loading;
    }

    async fetchDocument(url) {
      let error;
      for (let attempt = 0; attempt < 2; attempt++) {
        try {
          const response = await fetch(url, { signal: this.controller.signal });
          if (!response.ok) throw new Error(`Recommendations HTTP ${response.status}`);
          return new DOMParser().parseFromString(await response.text(), 'text/html');
        } catch (caught) {
          error = caught;
          if (caught.name === 'AbortError') throw caught;
        }
      }
      throw error;
    }

    async load() {
      const selected = new Map();
      try {
        const source = JSON.parse(this.querySelector('[data-similar-source]').textContent);
        if (!source.vehicle) {
          this.dataset.state = 'empty';
          return;
        }
        const limit = Math.min(8, Math.max(4, Number(this.dataset.limit) || 4));
        const accept = (root) => root.querySelectorAll('[data-similar-candidate]').forEach((element) => {
          try {
            const candidate = JSON.parse(element.querySelector('[data-similar-product]').textContent);
            const card = element.querySelector('[data-product-card]');
            if (card && isSimilarTyre(source, candidate)) selected.set(candidate.ean || String(candidate.id), { candidate, card });
          } catch (_) { /* Ignore malformed individual candidates. */ }
        });
        try {
          const recommended = await this.fetchDocument(this.dataset.url);
          const candidates = recommended.querySelector('[data-similar-candidates]');
          if (candidates) accept(candidates.content);
        } catch (error) {
          if (error.name === 'AbortError') throw error;
        }
        if (selected.size < limit && /^tyresize[a-z0-9]+$/i.test(source.sizeTag) && /^[a-z-]+$/i.test(source.vehicle)) {
          const url = new URL(this.dataset.searchUrl, window.location.origin);
          const query = [`tag:${source.sizeTag}`, `tag:${source.vehicle}`];
          if (/^[a-z-]+$/i.test(source.season || '')) query.push(`tag:${source.season}`);
          url.search = new URLSearchParams({ q: query.join(' AND '), type: 'product', section_id: 'tyre-similar-results', 'options[unavailable_products]': 'hide', 'options[prefix]': 'none', sort_by: 'price-ascending' });
          let page = 1;
          do {
            url.searchParams.set('page', String(page));
            let results;
            try {
              results = await this.fetchDocument(url.href);
            } catch (error) {
              if (error.name === 'AbortError' || !selected.size) throw error;
              break; // Keep valid alternatives already found if the next request fails.
            }
            accept(results);
            const nextPage = Number(results.querySelector('[data-similar-results]')?.dataset.nextPage);
            page = nextPage > page ? nextPage : 0;
          } while (page && selected.size < limit);
        }
        const cards = [...selected.values()].sort((a, b) => Math.abs(a.candidate.price - source.price) - Math.abs(b.candidate.price - source.price)).slice(0, limit);
        this.querySelector('[data-similar-grid]').replaceChildren(...cards.map(({ card }) => card));
        this.hidden = cards.length === 0;
        this.dataset.state = cards.length ? 'ready' : 'empty';
      } catch (error) {
        this.dataset.state = error.name === 'AbortError' ? 'cancelled' : 'error';
      }
    }
  }

  function initMobileBuyBar() {
    const bar = document.querySelector('[data-mobile-buy-bar]');
    const product = document.querySelector('g-product');
    const mainButton = product?.querySelector('[data-add-to-cart]');
    const barButton = bar?.querySelector('[data-mobile-buy-submit]');
    const barPrice = bar?.querySelector('[data-mobile-buy-price]');
    if (!bar || !product || !mainButton || !barButton || !barPrice || bar.dataset.initialized) return;
    bar.dataset.initialized = 'true';

    const mobile = window.matchMedia('(max-width: 749px)');
    const page = product.closest('.product-page');
    page?.setAttribute('data-buy-dock-ready', '');
    const sync = () => {
      const currentPrice = product.querySelector('[data-product-price]');
      const total = product.querySelector('[data-product-total]');
      const price = (total || currentPrice)?.textContent.trim() || '—';
      if (barPrice.textContent !== price) barPrice.textContent = price;
      barButton.disabled = mainButton.disabled;
      const label = barButton.querySelector('[data-mobile-buy-label]');
      const mainLabel = mainButton.querySelector('span')?.textContent || mainButton.textContent;
      if (label && label.textContent !== mainLabel) label.textContent = mainLabel;
      barButton.setAttribute('aria-busy', mainButton.getAttribute('aria-busy') || 'false');
      bar.classList.toggle('is-visible', mobile.matches);
      bar.setAttribute('aria-hidden', String(!mobile.matches));
      bar.inert = !mobile.matches;
      document.body.classList.toggle('product-dock-active', mobile.matches);
    };

    const stateObserver = new MutationObserver(sync);
    stateObserver.observe(product, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'aria-busy'] });

    barButton.addEventListener('click', () => {
      if (mainButton.disabled) return;
      const form = mainButton.closest('form');
      if (!form) return;
      if (typeof form.requestSubmit === 'function') form.requestSubmit(mainButton);
      else mainButton.click();
    });
    if (mobile.addEventListener) mobile.addEventListener('change', sync);
    else mobile.addListener(sync);
    sync();
  }

  if (!customElements.get('g-product')) customElements.define('g-product', GommaDotProduct);
  if (!customElements.get('product-recommendations')) customElements.define('product-recommendations', ProductRecommendations);
  initMobileBuyBar();
  document.querySelectorAll('.product-detail-nav a, .product-review-link').forEach((link) => link.addEventListener('click', (event) => {
    const target = document.querySelector(link.hash);
    if (!target) return;
    event.preventDefault();
    event.stopPropagation();
    if (target.tagName === 'DETAILS') target.open = true;
    target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
    target.scrollIntoView({ block: 'start', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    history.replaceState({}, '', link.hash);
  }));
})();
